module.exports = __webpack_public_path__ + "static/media/bartle@2x.ff7b6e94.png";